export default __webpack_public_path__ + "static/cypher-capital@2x-07c9e1b5e578fc96c954663129d9f76f.png";